import "./styles.css";

/**
 * @function MobileOSGStatementTable
 * @return {React.Component}
 * @exported false
 * @description The mobile view for "OSG Statements".
 * @example
 * <MobileOSGStatementTable />
 */

export default function MobileOSGStatementTable(props) {
    return(
      <div className="osg-statements-no-available-documents-widget">
        <p className="osg-statements-no-available-documents-text text-left">eStatements are available through our online banking portal. Please
            log in from your desktop or mobile browser to access them.
        </p>
      </div>
    );
  }